

const CTA = () => {

    return (
        <>
            <button className="btn-cta">CONTACT</button>
        </>
    )
    }

    export default CTA